export default __webpack_public_path__ + "img/WB_RT_NOMA_EF.bc1e44d1f89134136d155181f2c0b958.jpg";